import { SignatureProviderTypeEnum } from "../constants/signature-provider-type.enum";

export class SignatureProvider {
    public description!: string;
    public logo!: string;
    public name!: string;
    public parameters!: [];
    public requiresExternalAccount!: boolean;
    public requiresPlugin!: boolean;
    public signatureProviderType!: string;
    public signUrl!: string;
}

export class Provider {
    public default!: boolean;
    public eidasAssuranceLevel!: string;
    public id!: string;
    public logo!: string;
    public name!: string;
    public parameters: string[] = [];
    public requiresExternalAccount!: boolean;
    public requiresPlugin!: boolean;
    public signatureProviderType!: SignatureProviderTypeEnum;
    public testProfile: boolean = false;
}

export class SignatureProviderAvailability{
    public selectedSignatureProviders: Provider[] = [];
    public disableSignatureProviders: boolean = false;
}